module.exports = __webpack_public_path__ + "img/device001.2852ef64.png";